
import {downloadGzipCompressed} from '../utils.js';

const hex2rgba = (hexstr, out_type) => {
    out_type = out_type === undefined ? 'float' : out_type;

    const match = hexstr.match(/#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?/i);
    let rgba = match.slice(1).filter(c => c !== undefined).map(c => parseInt(c, 16));

    if (out_type == 'float') {
        rgba = rgba.map(c => c / 255);
    }

    return rgba;
}

const rgba2hex = (rgba, in_type) => {
    in_type = in_type === undefined ? 'float' : in_type;

    if (in_type == 'float') {
        rgba = rgba.map(c => Math.round(c * 255))
    }

    return '#' + rgba.map(c => c.toString(16).padStart(2, '0').toUpperCase()).join('');
}

function downloadField(rem_fname) {
    return downloadGzipCompressed(rem_fname)
        .then(data_packed => {
            const dims = new Uint16Array(data_packed.buffer, 0, 2);
            const [nlat, nlon] = [...dims];

            const lats = new Float32Array(data_packed.buffer, 4, nlat);
            const lons = new Float32Array(data_packed.buffer, 4 + 4 * nlat, nlon);
            const data = new Float32Array(data_packed.buffer, 4 + 4 * (nlat + nlon), nlat * nlon);

            const actual_width = Math.pow(2, Math.ceil(Math.log2(nlon)));
            const actual_height = Math.pow(2, Math.ceil(Math.log2(nlat)));
            const data_pad = new Float32Array(actual_width * actual_height);

            for (let irow = 0; irow < nlat; irow++) {
                data_pad.set(data.slice(irow * nlon, (irow + 1) * nlon), irow * actual_width);
                data_pad.set(data.slice((irow + 1) * nlon - 1, (irow + 1) * nlon), irow * actual_width + nlon);
            }
            data_pad.set(data.slice((nlat - 1) * nlon, nlat * nlon), nlat * actual_width);

            return {'nlats': nlat, 'nlons': nlon, 'lats': lats, 'lons': lons, 'data': data_pad, 
                'tex_width': actual_width, 'tex_height': actual_height};
        });
}

function downloadHodographs(rem_fname) {
    return downloadGzipCompressed(rem_fname)
        .then(data_packed => {
            const n_profiles = new Uint16Array(data_packed.buffer, 0, 1)[0];
            const profile_lengths = new Uint8Array(data_packed.buffer, 2, n_profiles);
            const n_pad = 4 - (n_profiles + 2) % 4;

            let i_start = n_profiles + 2 + n_pad;
            const profiles = [...profile_lengths].map(prof_len => {
                const [lat, lon] = new Float32Array(data_packed.buffer, i_start, 2);
                const [jlat, ilon] = new Uint16Array(data_packed.buffer, i_start + 8, 2);
                const [storm_u, storm_v] = new Float32Array(data_packed.buffer, i_start + 12, 2);

                const u = new Float32Array(data_packed.buffer, i_start + 20, prof_len);
                const v = new Float32Array(data_packed.buffer, i_start + 20 + 4 * prof_len, prof_len);
                const z = new Float32Array(data_packed.buffer, i_start + 20 + 2 * 4 * prof_len, prof_len);

                i_start += (20 + 3 * 4 * prof_len);

                return {'lat': lat, 'lon': lon, 'jlat': jlat, 'ilon': ilon, 'smu': storm_u, 'smv': storm_v, 
                        'u': u, 'v': v, 'z': z};
            });

            return profiles;
        });
}

function getMinZoom(jlat, ilon) {
    const thin_fac_base = 32; // z6 = 1, z5 = 2, z4 = 4, z3 = 8, z2 = 16, z1 = 32;
    const zoom_base = 1;

    let zoom = zoom_base;
    let thin_fac = thin_fac_base;

    while (((jlat % thin_fac) != 0) || ((ilon % thin_fac) != 0)) {
        zoom += 1;
        thin_fac /= 2;
    }

    return zoom;
}

export {hex2rgba, rgba2hex, downloadField, downloadHodographs, getMinZoom};